import React from 'react';
import { SkeletonLine } from 'src/components/Helpers/SkeletonLine';
import { Svg } from 'src/components/Svg/Svg';

import { Button } from '../Button/Button';

import { FilterModalTrigger } from './FilterModalContext';
import classes from './Toolbar.scss';

type Props = {
    loading?: boolean;
    sorter?: React.ReactNode;
    stats?: React.ReactNode;
};

export const ToolbarLayout: React.FunctionComponent<Props> = ({ loading, sorter, stats }) => {
    return (
        <div className={classes.toolbar}>
            <FilterModalTrigger>
                <Button className={classes.toolbarFilter}>
                    <Svg className={classes.toolbarFiltersIcon} name="filters" />
                    Show Filters
                </Button>
            </FilterModalTrigger>
            {Boolean(stats && sorter) && (
                <>
                    <div className={classes.toolbarSort}>{sorter}</div>
                    <div className={classes.toolbarCount}>
                        <p className={classes.toolbarCountText}>{loading ? <SkeletonLine width={10} /> : stats}</p>
                    </div>
                </>
            )}
        </div>
    );
};
